module.exports = __webpack_public_path__ + "static/img/request-data-sheet.e6b15a47.png";